export default "__VITE_ASSET__DhW7xf3l__"